import { Image } from "antd";
import React, { useEffect, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { CardContainer } from "../../../../../components/Card/CardContainer";
import { getPointDetail } from "../../../../../datasource/OrderPointDatasource";

export const GlobalStyle = createGlobalStyle`
  .ant-image-preview-close {
    display: none !important;
  }
  .ant-image-preview-wrap {
    background-color:  #1e1e1e !important;
  }
`;

function PreviewShipDoc() {
  const orderPointId = window.location.pathname.split("/")[3];

  const [visible] = useState(true);
  const [detail, setDetail] = useState<any>();

  const getDetailPointApprove = async () => {
    const params = {
      orderPointId: orderPointId,
      campaignProgramId: "",
    };
    const res = await getPointDetail(params);
    setDetail(res);
  };

  useEffect(() => {
    getDetailPointApprove();
  }, [orderPointId]);

  return (
    <div>
      <GlobalStyle />
      <Image
        style={{ display: "none" }}
        src={detail?.deliverySheet}
        preview={{
          visible,
          src: `${detail?.deliverySheet}`,
        }}
      />
    </div>
  );
}

export default PreviewShipDoc;
